<template>
  <section id="offer-card">
    <div class="card">
      <div v-if="loading" class="p-3">
        <HorizontalLinesLoader />
      </div> 
      <div v-else
        class="card-header d-flex justify-content-between align-items-center p-2"
      >
        <div class="d-flex">
          <div class="card-header__offer-icon" aria-label="icon depicting an offer icon">
              <!-- background image is added here in the theme or main.scss file -->
              <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="fill" d="M9.14325 9.37207H27.429V11.2006H9.14325V9.37207ZM9.14325 18.5149H18.3844V20.3435H9.14325V18.5149ZM26.7181 13.9435H9.14325V15.7721H24.8907L26.7181 13.9435ZM14.621 33.2258C14.9284 33.5783 15.3185 33.8489 15.7564 34.0133C16.1943 34.1776 16.6661 34.2306 17.1295 34.1675H26.0472C26.2594 34.1675 26.4629 34.0832 26.6129 33.9332C26.763 33.7832 26.8472 33.5797 26.8472 33.3675C26.8472 33.1553 26.763 32.9518 26.6129 32.8018C26.4629 32.6518 26.2594 32.5675 26.0472 32.5675H17.1295C16.0884 32.5492 16.2735 31.6452 16.4198 31.3652C16.6105 31.0366 16.7591 30.6852 16.8621 30.3195C16.9304 30.0252 16.8982 29.7165 16.7706 29.4427C16.643 29.1688 16.4274 28.9456 16.1581 28.8086C15.7255 28.6137 15.2409 28.566 14.7785 28.6727C14.3162 28.7794 13.9015 29.0347 13.5981 29.3995C13.205 29.8052 12.6587 30.4258 12.1352 31.0292C12.4587 29.7618 12.8781 28.1355 13.2895 26.5492C13.4074 26.1878 13.384 25.7951 13.2238 25.4502C13.0637 25.1054 12.7789 24.8341 12.4267 24.6909C12.0366 24.5571 11.6103 24.5762 11.2338 24.7444C10.8573 24.9126 10.5587 25.2174 10.3981 25.5972C9.90439 26.5469 5.99582 33.0966 5.95696 33.1629C5.90308 33.2531 5.86749 33.3531 5.85223 33.457C5.83697 33.561 5.84234 33.6669 5.86802 33.7688C5.8937 33.8707 5.9392 33.9665 6.00191 34.0508C6.06463 34.1351 6.14333 34.2062 6.23353 34.2601C6.4157 34.3689 6.63363 34.4009 6.83938 34.349C7.04514 34.2971 7.22186 34.1657 7.33067 33.9835C7.47696 33.7378 10.597 28.5115 11.581 26.7664C10.8404 29.6235 10.0244 32.8029 9.97639 33.0886C9.92236 33.2987 9.93857 33.5207 10.0226 33.7206C10.1066 33.9206 10.2537 34.0876 10.4415 34.1961C10.6507 34.2998 10.8885 34.331 11.1174 34.2846C11.3463 34.2383 11.5532 34.117 11.7055 33.9401C11.8495 33.8098 12.1192 33.5001 12.7992 32.7104C13.4328 31.9652 14.0817 31.2332 14.7455 30.5149C14.9947 30.2521 15.1455 30.3686 14.9992 30.6269C14.7131 30.9885 14.5275 31.4193 14.4613 31.8757C14.3951 32.332 14.4494 32.7978 14.621 33.2258Z" fill="#4095B1"/>
                <path class="fill" d="M32.0034 24.7947V36.5718H4.57478V4.57185H32.0034V10.2781L33.5234 8.75813C33.7573 8.52736 34.0139 8.32061 34.2891 8.14099V3.42899C34.2891 3.12589 34.1687 2.8352 33.9543 2.62087C33.74 2.40654 33.4493 2.28613 33.1462 2.28613H3.43192C3.12882 2.28613 2.83812 2.40654 2.6238 2.62087C2.40947 2.8352 2.28906 3.12589 2.28906 3.42899V37.7147C2.28906 38.0178 2.40947 38.3085 2.6238 38.5228C2.83812 38.7372 3.12882 38.8576 3.43192 38.8576H33.1462C33.4493 38.8576 33.74 38.7372 33.9543 38.5228C34.1687 38.3085 34.2891 38.0178 34.2891 37.7147V24.4884C33.5881 24.8599 32.7774 24.9685 32.0034 24.7947Z" fill="#4095B1"/>
                <path class="fill" d="M39.0016 13.5561L38.4039 12.9584C38.7094 12.5547 38.864 12.0569 38.8411 11.5511C38.8181 11.0454 38.619 10.5636 38.2782 10.1893C37.8358 9.79937 37.2573 9.60005 36.6686 9.63473C36.08 9.66941 35.5288 9.93527 35.1353 10.3744L20.821 24.6864L19.8645 28.2773C19.8493 28.3243 19.8475 28.3745 19.8591 28.4225C19.8708 28.4704 19.8955 28.5142 19.9305 28.549C19.9656 28.5838 20.0095 28.6082 20.0576 28.6196C20.1056 28.6309 20.1559 28.6287 20.2027 28.6133L23.781 27.6453L37.1433 14.283L37.7079 14.8487C37.7473 14.8881 37.7786 14.9348 37.7999 14.9863C37.8213 15.0378 37.8323 15.093 37.8323 15.1487C37.8323 15.2044 37.8213 15.2596 37.7999 15.3111C37.7786 15.3626 37.7473 15.4093 37.7079 15.4487L32.0885 21.0681C31.917 21.2397 31.8208 21.4723 31.8209 21.7148C31.821 21.9573 31.9175 22.1899 32.089 22.3613C32.2606 22.5327 32.4932 22.6289 32.7357 22.6288C32.9782 22.6287 33.2108 22.5323 33.3822 22.3607L39.0016 16.7413C39.424 16.3187 39.6612 15.7456 39.6612 15.1481C39.6612 14.5506 39.424 13.9776 39.0016 13.555V13.5561Z" fill="#4095B1"/>
              </svg>
          </div>
          <div>
            <div class="fs-16 card-header__primary-text fw-500">Offers</div>
            <div class="fs-14 card-header__secondary-text">
              {{
                filteredOffers?.length ? 'You have pending job offers' : 'No pending job offers'
              }}
            </div>
          </div>
        </div>

        <div>
          <span
            v-if="filteredOffers?.length"
            class="card-header__material-icons cursor-pointer d-md-none"
            @click.prevent="showOffer = !showOffer"
          >
            expand_more
          </span>
        </div>
      </div>
      <transition
        name="fade"
        enter-active-class="animate__animated animate__fadeIn animate__delay-2"
        leave-active-class="animate__animated animate__fadeOut animate__delay-2"
      >
        <div v-if="filteredOffers?.length" v-show="showOffer" class="card-body p-3">
          <div
            v-for="(offer, offerId) in filteredOffers"
            class="d-flex justify-content-between align-items-center"
            :class="{'border-bottom mb-3 pb-2': offerId !== filteredOffers?.length - 1}"
            :key="offer.title"
          >
            <div>
              <h6>{{ offer.job.title }}</h6>
              <p class="text-muted m-0">
                Due date:
                {{
                  $moment(offer.offer_letter_expires_at).format("hh:mma, Do MMM, YYYY")
                }}
              </p>
            </div>
            <div>
              <a v-b-popover.hover.top="'Click to view offer'" :href="`${clientDetails.url}accept-reject/${offer.onboarding_applicant_id}`" target="_blank">
                <svg
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.25 2C2.2835 2 1.5 2.7835 1.5 3.75V11.25C1.5 12.2165 2.2835 13 3.25 13H10.75C11.7165 13 12.5 12.2165 12.5 11.25V9.25C12.5 8.83579 12.8358 8.5 13.25 8.5C13.6642 8.5 14 8.83579 14 9.25V11.25C14 13.0449 12.5449 14.5 10.75 14.5H3.25C1.45507 14.5 0 13.0449 0 11.25V3.75C0 1.95507 1.45507 0.5 3.25 0.5H5.25C5.66421 0.5 6 0.835786 6 1.25C6 1.66421 5.66421 2 5.25 2H3.25ZM7.5 1.25C7.5 0.835786 7.83579 0.5 8.25 0.5H13.25C13.6642 0.5 14 0.835786 14 1.25V6.25C14 6.66421 13.6642 7 13.25 7C12.8358 7 12.5 6.66421 12.5 6.25V3.06066L8.78033 6.78033C8.48744 7.07322 8.01256 7.07322 7.71967 6.78033C7.42678 6.48744 7.42678 6.01256 7.71967 5.71967L11.4393 2H8.25C7.83579 2 7.5 1.66421 7.5 1.25Z"
                    fill="#777777"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import HorizontalLinesLoader from "../../admin/jobs/job-management/applicant-tracking-system/includes/loaders/utility/HorizontalLines.vue"

export default {
  name: "JobOfferCard", 
  props: {
    offers: {
      type: Array,
      default: [],
    },
    loading: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    HorizontalLinesLoader
  },
  data() {
    return {
      showOffer: true,
      clientDetails: {}
    }
  },
  computed:{
    // this is to ensure that only offers that have not passed the expiry date, would be displayed to the candidate
    filteredOffers() {
      return this.offers.filter(item => this.$moment().isSameOrBefore(item.offer_letter_expires_at))
    }
  },
  mounted() {
    const client = JSON.parse(sessionStorage.getItem('company'))?.client;
    if(client) {
      this.clientDetails = client.hrms_details || {}
    }
  }
}
</script>
